export default __webpack_public_path__ + "static/media/img1.a6a3539b.png";